/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DamageCase } from '../models';
// @ts-ignore
import { DocumentSign } from '../models';
// @ts-ignore
import { PDFDocument } from '../models';
// @ts-ignore
import { PDFTypes } from '../models';
// @ts-ignore
import { PdfDamagecasesTypeTempSavePost200Response } from '../models';
// @ts-ignore
import { PdfPublishinappPostRequest } from '../models';
/**
 * PdfApi - axios parameter creator
 * @export
 */
export const PdfApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a list of documents of this damagecase
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecaseDocumentlistIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecaseDocumentlistIdGet', 'id', id)
            const localVarPath = `/pdf/damagecase/documentlist/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all customer signing requests
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdAllSignableDocumentGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdAllSignableDocumentGet', 'id', id)
            const localVarPath = `/pdf/damagecases/{id}/all/signableDocument`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove all files by type from damagecase
         * @param {number} id DamageCase ID
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdRemoveTypeDelete: async (id: number, type: PDFTypes, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdRemoveTypeDelete', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdRemoveTypeDelete', 'type', type)
            const localVarPath = `/pdf/damagecases/{id}/remove/{type}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post new customer sign request
         * @param {string} id 
         * @param {DocumentSign} [documentSign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdSignableDocumentPost: async (id: string, documentSign?: DocumentSign, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdSignableDocumentPost', 'id', id)
            const localVarPath = `/pdf/damagecases/{id}/signableDocument`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(documentSign, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download AppEmployeeDatasheet
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTempQrsheetGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTempQrsheetGet', 'id', id)
            const localVarPath = `/pdf/damagecases/{id}/temp/qrsheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the last uuid of documents with this type
         * @param {number} id 
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeGet: async (id: number, type: PDFTypes, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeGet', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeGet', 'type', type)
            const localVarPath = `/pdf/damagecases/{id}/{type}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} label 
         * @param {string} [miscoverride] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadLabelPost: async (id: string, type: string, label: string, miscoverride?: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadLabelPost', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadLabelPost', 'type', type)
            // verify required parameter 'label' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadLabelPost', 'label', label)
            const localVarPath = `/pdf/damagecases/{id}/{type}/upload/{label}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"label"}}`, encodeURIComponent(String(label)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (miscoverride !== undefined) {
                localVarQueryParameter['miscoverride'] = miscoverride;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadPost: async (id: string, type: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadPost', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadPost', 'type', type)
            const localVarPath = `/pdf/damagecases/{id}/{type}/upload`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} repairExtensionId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost: async (id: string, type: string, repairExtensionId: string, body?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost', 'id', id)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost', 'type', type)
            // verify required parameter 'repairExtensionId' is not null or undefined
            assertParamExists('pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost', 'repairExtensionId', repairExtensionId)
            const localVarPath = `/pdf/damagecases/{id}/{type}/upload/repairExtension/{repairExtensionId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"repairExtensionId"}}`, encodeURIComponent(String(repairExtensionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeSavePost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesPaymentTypeSavePost', 'type', type)
            const localVarPath = `/pdf/damagecases/payment/{type}/save`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeTempPost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesPaymentTypeTempPost', 'type', type)
            const localVarPath = `/pdf/damagecases/payment/{type}/temp`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeSavePost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesTypeSavePost', 'type', type)
            const localVarPath = `/pdf/damagecases/{type}/save`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeTempSavePost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesTypeTempSavePost', 'type', type)
            const localVarPath = `/pdf/damagecases/{type}/temp/save`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the file of the document
         * @param {string} uuid 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidFileGet: async (uuid: string, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('pdfDamagecasesUuidFileGet', 'uuid', uuid)
            const localVarPath = `/pdf/damagecases/{uuid}/file`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarRequestOptions.responseType = 'arraybuffer'

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the temp file of the document
         * @param {string} uuid 
         * @param {string} [filename] 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidTempFileGet: async (uuid: string, filename?: string, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('pdfDamagecasesUuidTempFileGet', 'uuid', uuid)
            const localVarPath = `/pdf/damagecases/{uuid}/temp/file`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)
	    localVarRequestOptions.responseType = 'arraybuffer'

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the PDF to the specefic email
         * @param {string} email 
         * @param {Array<string>} [uuid] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfMailEmailPost: async (email: string, uuid?: Array<string>, customerId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('pdfMailEmailPost', 'email', email)
            const localVarPath = `/pdf/mail/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (uuid) {
                localVarQueryParameter['uuid'] = uuid;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customer_id'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publish PDFs in Customer App
         * @param {PdfPublishinappPostRequest} [pdfPublishinappPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfPublishinappPost: async (pdfPublishinappPostRequest?: PdfPublishinappPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pdf/publishinapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pdfPublishinappPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update PDF
         * @param {string} uuid 
         * @param {PDFDocument} [pDFDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfUuidPut: async (uuid: string, pDFDocument?: PDFDocument, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('pdfUuidPut', 'uuid', uuid)
            const localVarPath = `/pdf/{uuid}`
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pDFDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch documents by vehicle id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfVehiclesIdGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pdfVehiclesIdGet', 'id', id)
            const localVarPath = `/pdf/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PdfApi - functional programming interface
 * @export
 */
export const PdfApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PdfApiAxiosParamCreator(configuration)
    return {
        /**
         * Get a list of documents of this damagecase
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecaseDocumentlistIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecaseDocumentlistIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all customer signing requests
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdAllSignableDocumentGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdAllSignableDocumentGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove all files by type from damagecase
         * @param {number} id DamageCase ID
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdRemoveTypeDelete(id: number, type: PDFTypes, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdRemoveTypeDelete(id, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post new customer sign request
         * @param {string} id 
         * @param {DocumentSign} [documentSign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdSignableDocumentPost(id: string, documentSign?: DocumentSign, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdSignableDocumentPost(id, documentSign, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download AppEmployeeDatasheet
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTempQrsheetGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTempQrsheetGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the last uuid of documents with this type
         * @param {number} id 
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeGet(id: number, type: PDFTypes, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeGet(id, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} label 
         * @param {string} [miscoverride] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeUploadLabelPost(id: string, type: string, label: string, miscoverride?: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeUploadLabelPost(id, type, label, miscoverride, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeUploadPost(id: string, type: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeUploadPost(id, type, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} repairExtensionId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id: string, type: string, repairExtensionId: string, body?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id, type, repairExtensionId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesPaymentTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesPaymentTypeSavePost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesPaymentTypeTempPost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesPaymentTypeTempPost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesTypeSavePost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesTypeTempSavePost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the file of the document
         * @param {string} uuid 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesUuidFileGet(uuid: string, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesUuidFileGet(uuid, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Download the temp file of the document
         * @param {string} uuid 
         * @param {string} [filename] 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesUuidTempFileGet(uuid: string, filename?: string, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesUuidTempFileGet(uuid, filename, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send the PDF to the specefic email
         * @param {string} email 
         * @param {Array<string>} [uuid] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfMailEmailPost(email: string, uuid?: Array<string>, customerId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfMailEmailPost(email, uuid, customerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Publish PDFs in Customer App
         * @param {PdfPublishinappPostRequest} [pdfPublishinappPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfPublishinappPost(pdfPublishinappPostRequest?: PdfPublishinappPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfPublishinappPost(pdfPublishinappPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update PDF
         * @param {string} uuid 
         * @param {PDFDocument} [pDFDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfUuidPut(uuid: string, pDFDocument?: PDFDocument, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfUuidPut(uuid, pDFDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Fetch documents by vehicle id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfVehiclesIdGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PDFDocument>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfVehiclesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PdfApi - factory interface
 * @export
 */
export const PdfApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PdfApiFp(configuration)
    return {
        /**
         * Get a list of documents of this damagecase
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecaseDocumentlistIdGet(id: number, options?: any): AxiosPromise<string> {
            return localVarFp.pdfDamagecaseDocumentlistIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all customer signing requests
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdAllSignableDocumentGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdAllSignableDocumentGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove all files by type from damagecase
         * @param {number} id DamageCase ID
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdRemoveTypeDelete(id: number, type: PDFTypes, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdRemoveTypeDelete(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Post new customer sign request
         * @param {string} id 
         * @param {DocumentSign} [documentSign] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdSignableDocumentPost(id: string, documentSign?: DocumentSign, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdSignableDocumentPost(id, documentSign, options).then((request) => request(axios, basePath));
        },
        /**
         * Download AppEmployeeDatasheet
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTempQrsheetGet(id: string, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesIdTempQrsheetGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the last uuid of documents with this type
         * @param {number} id 
         * @param {PDFTypes} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeGet(id: number, type: PDFTypes, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesIdTypeGet(id, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} label 
         * @param {string} [miscoverride] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadLabelPost(id: string, type: string, label: string, miscoverride?: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdTypeUploadLabelPost(id, type, label, miscoverride, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadPost(id: string, type: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdTypeUploadPost(id, type, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload the file of the document
         * @param {string} id 
         * @param {string} type 
         * @param {string} repairExtensionId 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id: string, type: string, repairExtensionId: string, body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id, type, repairExtensionId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesPaymentTypeSavePost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesPaymentTypeTempPost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesPaymentTypeTempPost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the pdf file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesTypeSavePost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesTypeTempSavePost(type, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the file of the document
         * @param {string} uuid 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidFileGet(uuid: string, damageCase?: DamageCase, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesUuidFileGet(uuid, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the temp file of the document
         * @param {string} uuid 
         * @param {string} [filename] 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesUuidTempFileGet(uuid: string, filename?: string, damageCase?: DamageCase, options?: any): AxiosPromise<any> {
            return localVarFp.pdfDamagecasesUuidTempFileGet(uuid, filename, damageCase, options).then((request) => request(axios, basePath));
        },
        /**
         * Send the PDF to the specefic email
         * @param {string} email 
         * @param {Array<string>} [uuid] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfMailEmailPost(email: string, uuid?: Array<string>, customerId?: number, options?: any): AxiosPromise<any> {
            return localVarFp.pdfMailEmailPost(email, uuid, customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Publish PDFs in Customer App
         * @param {PdfPublishinappPostRequest} [pdfPublishinappPostRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfPublishinappPost(pdfPublishinappPostRequest?: PdfPublishinappPostRequest, options?: any): AxiosPromise<void> {
            return localVarFp.pdfPublishinappPost(pdfPublishinappPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update PDF
         * @param {string} uuid 
         * @param {PDFDocument} [pDFDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfUuidPut(uuid: string, pDFDocument?: PDFDocument, options?: any): AxiosPromise<PDFDocument> {
            return localVarFp.pdfUuidPut(uuid, pDFDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch documents by vehicle id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfVehiclesIdGet(id: string, options?: any): AxiosPromise<Array<PDFDocument>> {
            return localVarFp.pdfVehiclesIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PdfApi - object-oriented interface
 * @export
 * @class PdfApi
 * @extends {BaseAPI}
 */
export class PdfApi extends BaseAPI {
    /**
     * Get a list of documents of this damagecase
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecaseDocumentlistIdGet(id: number, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecaseDocumentlistIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all customer signing requests
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdAllSignableDocumentGet(id: string, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdAllSignableDocumentGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove all files by type from damagecase
     * @param {number} id DamageCase ID
     * @param {PDFTypes} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdRemoveTypeDelete(id: number, type: PDFTypes, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdRemoveTypeDelete(id, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post new customer sign request
     * @param {string} id 
     * @param {DocumentSign} [documentSign] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdSignableDocumentPost(id: string, documentSign?: DocumentSign, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdSignableDocumentPost(id, documentSign, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download AppEmployeeDatasheet
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdTempQrsheetGet(id: string, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdTempQrsheetGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the last uuid of documents with this type
     * @param {number} id 
     * @param {PDFTypes} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdTypeGet(id: number, type: PDFTypes, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdTypeGet(id, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the file of the document
     * @param {string} id 
     * @param {string} type 
     * @param {string} label 
     * @param {string} [miscoverride] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdTypeUploadLabelPost(id: string, type: string, label: string, miscoverride?: string, body?: string, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdTypeUploadLabelPost(id, type, label, miscoverride, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the file of the document
     * @param {string} id 
     * @param {string} type 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdTypeUploadPost(id: string, type: string, body?: string, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdTypeUploadPost(id, type, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload the file of the document
     * @param {string} id 
     * @param {string} type 
     * @param {string} repairExtensionId 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id: string, type: string, repairExtensionId: string, body?: string, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesIdTypeUploadRepairExtensionRepairExtensionIdPost(id, type, repairExtensionId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the pdf file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesPaymentTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesPaymentTypeSavePost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the temporary file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesPaymentTypeTempPost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesPaymentTypeTempPost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the pdf file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesTypeSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesTypeSavePost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the temporary file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesTypeTempSavePost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the file of the document
     * @param {string} uuid 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesUuidFileGet(uuid: string, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesUuidFileGet(uuid, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the temp file of the document
     * @param {string} uuid 
     * @param {string} [filename] 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfDamagecasesUuidTempFileGet(uuid: string, filename?: string, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfDamagecasesUuidTempFileGet(uuid, filename, damageCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send the PDF to the specefic email
     * @param {string} email 
     * @param {Array<string>} [uuid] 
     * @param {number} [customerId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfMailEmailPost(email: string, uuid?: Array<string>, customerId?: number, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfMailEmailPost(email, uuid, customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publish PDFs in Customer App
     * @param {PdfPublishinappPostRequest} [pdfPublishinappPostRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfPublishinappPost(pdfPublishinappPostRequest?: PdfPublishinappPostRequest, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfPublishinappPost(pdfPublishinappPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update PDF
     * @param {string} uuid 
     * @param {PDFDocument} [pDFDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfUuidPut(uuid: string, pDFDocument?: PDFDocument, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfUuidPut(uuid, pDFDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch documents by vehicle id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PdfApi
     */
    public pdfVehiclesIdGet(id: string, options?: AxiosRequestConfig) {
        return PdfApiFp(this.configuration).pdfVehiclesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}
